export const TENANT_INPUT_ID = "free-user-tenant-input";
export const EMAIL_INPUT_ID = "free-user-email-input";
export const PASSWORD_INPUT_ID = "free-user-password-input";
export const OTHER_SOURCE_INPUT_ID = "other-source-input";
export const REFERRAL_CODE_INPUT_ID = "free-user-referral-code";

// Leading free-email providers that the backend allows through when a valid
// referral code is present. Mirrors LEADING_FREE_PROVIDERS in
// app/free_mail_domains.py — keep in sync.
export const LEADING_FREE_PROVIDERS = new Set([
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "ymail.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "gmx.net",
  "gmx.de",
  "yandex.com",
  "yandex.ru",
  "mail.com",
  "mail.ru",
  "fastmail.com",
  "tutanota.com",
  "zoho.com",
]);

export const AI_TOOL_OPTIONS = [
  { id: "chatgpt", label: "ChatGPT" },
  { id: "claude", label: "Claude" },
  { id: "cursor", label: "Cursor" },
  { id: "copilot", label: "GitHub Copilot" },
  { id: "gemini", label: "Gemini" },
] as const;

export type AiToolId = (typeof AI_TOOL_OPTIONS)[number]["id"];

export const SIGNUP_SOURCE_OPTIONS = [
  {
    label: "Recommendation from a colleague or friend",
    value: "Recommendation from a colleague or friend",
  },
  { label: "VSCode Marketplace", value: "VSCode Marketplace" },
  {
    label: "Social Media (e.g., Twitter, LinkedIn, Facebook)",
    value: "Social Media (e.g., Twitter, LinkedIn, Facebook)",
  },
  { label: "Online Advertisement", value: "Online Advertisement" },
  { label: "Blog Post", value: "Blog Post" },
  {
    label: "Educational Course or Workshop",
    value: "Educational Course or Workshop",
  },
  { label: "Other", value: "Other" },
];
